import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import {
  GridColumnMenuSortItem,
  gridSortModelSelector,
  useGridApiContext,
  useGridSelector,
  type GridColumnMenuItemProps,
} from '@mui/x-data-grid-premium'
import { useTranslation } from 'react-i18next'

interface SortItemProps extends GridColumnMenuItemProps {
  onClearSort?: () => void
}

export const SortItem: React.FC<SortItemProps> = ({ onClearSort, ...props }) => {
  const { t } = useTranslation()
  const apiRef = useGridApiContext()
  const sortModel = useGridSelector(apiRef, gridSortModelSelector)
  const isSorted = sortModel.some(({ field }) => field === props.colDef.field)

  const handleClearSortClick = (event: React.MouseEvent<HTMLLIElement>) => {
    onClearSort?.()
    props.onClick(event)
  }

  return (
    <>
      <GridColumnMenuSortItem {...props} />
      {onClearSort && isSorted && (
        <MenuItem onClick={handleClearSortClick}>
          <ListItemIcon>
            <ClearIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('tableHeaderMenu::option::clearSort')}</ListItemText>
        </MenuItem>
      )}
    </>
  )
}
